//For local env
// export const ScreenNames: IScreenNamesTypes = {
//     defaultPath: "/*",
//     callbackmrv: "/callbackmrv",
//     callbackprv: "/callbackprv",
//     callbackmg: "/callbackmg",
// }
// //For server
export var ScreenNames = {
    defaultPath: "/*",
    callbackmrv: "/callback",
    callbackprv: "/callback",
    callbackmg: "/callback",
};
export var EUserType;
(function (EUserType) {
    EUserType["INTERNAL"] = "internal";
})(EUserType || (EUserType = {}));
export var EAssociateType;
(function (EAssociateType) {
    EAssociateType["FULL_ACCESS"] = "Full Access";
})(EAssociateType || (EAssociateType = {}));
export var PageSize = {
    EXTERNAL_DEFAULT: 30,
    INTERNAL_DEFAULT: 100,
    ALL: 1000,
};
export var allFinancialKeysInOrder = [
    //"Key Financial As of Date (USDmn)", // Handelled in the inner function		
    "Policyholders' Surplus (PHS)",
    "Adjusted Shareholders' Funds (ASHF)",
    "Capital & Surplus (C&S)",
    "Capacity",
    "Change in PHS %",
    "Change in ASHF %",
    "Change in C&S %",
    "Change in Capacity %",
    "Insurance Revenue",
    "Insurance Service Revenue",
    "Gross Premiums Written",
    "Net Premiums Written",
    "NPW to PHS %",
    "NPW to ASHF %",
    "Pre-tax Results to NPE %",
    "NPW / C&S %",
    "Risk-Based Capital %",
    "Adjusted Liabilities to Adjusted C&S %",
    "Liabilities to C&S %",
    "Life Tabular Mortality %",
    "Liquid Assets to Liabilities %",
    "Net Technical Reserves as % of NPW",
    "Liquid Assets as % of Net Tech Res (ex linked provision)",
    "Investment Yield %",
    "Liquid Assets / Net Technical Reserves %",
    "Net Leverage Ratio %",
    "Pre-Tax Results",
    "Combined Ratio %",
    "Net Income",
    "Estimated Assets Under Management",
    "Pre-tax Return on PHS (ROE) %", //mismatch in excel %  ----corrected awated testing
    "Operating Return on C&S %", //mismatch in excel roadmap	--corrected Awaited Testing
    "Return on C&S %", //mismatch in excel roadmap	 ---corrected and awated testing
    "Pre-tax Return on ASHF %",
    "Pre-tax Return on C&S %", //mismatch in excel roadmap   ---corrected Awated Testing
    "Reported Currency",
    "Conversion Rate to USD",
];
